import type { StreamingChatId, StreamingMessageId } from "@storytell/streaming";
import { Show, For, createMemo } from "solid-js";
import { useWire } from "~/wire";
import { OperationRenderer } from "./OperationRenderer";
import { PromptAckRenderer } from "./r";

export const MessageRenderer = (props: { messageId: StreamingMessageId; chatId: StreamingChatId }) => {
  const wire = useWire();
  const stream = wire.stream;

  const message = () => stream.message.get(props.messageId);

  const isLastMessage = createMemo(() => stream.chat.get(props.chatId)?.messages.at(-1) === props.messageId);

  return (
    <>
      <div
        data-message-renderer={props.messageId}
        class="scroll-mt-10"
        classList={{ "min-h-screen pb-40": isLastMessage() }}
      >
        <Show when={message()?.prompt}>{(prompt) => <PromptAckRenderer prompt={prompt()} />}</Show>
        <For each={message()?.operations}>
          {(operationId, index) => (
            <OperationRenderer operationId={operationId} index={index()} chatId={props.chatId} />
          )}
        </For>
      </div>

      <Show when={!isLastMessage()}>
        <div class="h-[1px] bg-primary-border" />
      </Show>
    </>
  );
};
